import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/jobs',
        name: 'jobs',
        component: () => import('../views/Jobs.vue')
    },
    {
        path: '/job/edit/:id',
        name: 'job-edit',
        component: () => import('../views/JobEdit.vue')
    },
    {
        path: '/job/create',
        name: 'job-create',
        component: () => import('../views/JobCreate.vue')
    },
    {
        path: '/admin/users',
        name: 'users',
        component: () => import('../views/admin/users/Users.vue')
    },
    {
        path: '/admin/users/create',
        name: 'user-create',
        component: () => import('../views/admin/users/UserCreate.vue')
    },
    {
        path: '/admin/users/edit/:id',
        name: 'user-edit',
        component: () => import('../views/admin/users/UserEdit.vue')
    },
    {
        path: '/admin/roles',
        name: 'roles',
        component: () => import('../views/admin/roles/Roles.vue')
    },
    {
        path: '/admin/role/create',
        name: 'role-create',
        component: () => import('../views/admin/roles/RoleCreate.vue')
    },
    {
        path: '/admin/role/edit/:id',
        name: 'role-edit',
        component: () => import('../views/admin/roles/RoleEdit.vue')
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
